import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import SpecialOfferPopup from './components/SpecialOfferPopup';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Main Website Component
const MainWebsite = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Services />
      <WhyChooseUs />
      <Gallery />
      <Testimonials />
      <Contact />
    </main>
    <Footer />
    <WhatsAppButton />
    <SpecialOfferPopup />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<MainWebsite />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
